<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ewqxqb/tc-custom/9780814732519.jpg?1719926997222" alt="This image is the cover for the book Seriatim"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seriatim
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“This absorbing collection of essay . . . goes far toward filling a void in the literature on the early justices of the world's most significant tribunal” (<i>Law and Politics Book Review</i>).</b></p><p>   </p><p> Seldom has American law seen a more towering figure than Chief Justice John Marshall. Yet even while acknowledging the indelible stamp Marshall put on the Supreme Court, it is possible—in fact necessary—to examine the pre-Marshall Court, and its justices, to gain a true understanding of the origins of American constitutionalism.  </p><p> The ten essays in this volume were specially commissioned for the book, each written by the leading authority on his or her particular subject. They examine such influential justices as John Jay, John Rutledge, William Cushing, James Wilson, John Blair, James Iredell, William Paterson, Samuel Chase, Oliver Ellsworth, and Bushrod Washington. The result is a fascinating window onto the origins of the most powerful court in the world, and on American constitutionalism itself. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Scott Douglas Gerber
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1214b719